function draw() {
    getFps();
    playerActions(playerData);
    getAllLines(playerData.direction);
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    drawLines3d();
    if (!running) return;
    requestAnimationFrame(draw);
}

function getFps() {
    thisLoop = new Date();
    if (thisLoop - lastLoop > 1000) {
        fps = fpsTick;
        delta = 60 / fps;
        lastLoop = thisLoop;
        fpsTick = 0;
    }
    fpsTick += 1;
}

function getDirectionValues(direction) {
    return {
        xChange: Math.cos(direction),
        yChange: Math.sin(direction),
    }
}

function checkCondtions(conditions) {
    if (!conditions) return true;
    let getItem;
    let cond;
    let conditionsMet = true;
    conditions.forEach(condition => {
        cond = condition.metaData;
        getItem = inventory.find(item => item.id === cond.checkItem)
        if (!eval(`${getItem.value} ${cond.conditionCheck} ${cond.checkValue}`)) conditionsMet = false;
    });
    return conditionsMet;
}

function actionEvents(eventData) {
    let currentEvent = mapEvents[eventData.wallDir][eventData.wallIndex];
    if (!checkCondtions(currentEvent.conditions)) return;
    eventData.actions.forEach(action =>{
        if (action.type === 'change') {
            let actionData = action.metaData;
            if (actionData.wallDirection === 'vert') vertWallList[actionData.wallNum] = actionData.newWallIdx;
            if (actionData.wallDirection  === 'horz') horzWallList[actionData.wallNum] = actionData.newWallIdx;
        }
        if (action.type === 'exchangeItem') {
            let actionData = action.metaData;
            let item = inventory.find(item => item.id === actionData.itemId)
            item.value += actionData.valueChange;
        }
    })
    currentEvent.available = false; // Stops event from being actioned again
    eventAvailable = resetEventAvailable();
    uiSettings({text: {newText: ''} });
    if (inventory[2].value > 0) uiSettings({endGame: true});
}

function keyPlayers(p) {
    if (controlsEnabled) {
        if (keyup) p.speed += (0.09 * delta);
        if (keydown) p.speed -= (0.09 * delta);
        if (keyleft) p.turnSpeed += (1 * delta);
        if (keyright) p.turnSpeed -= (1 * delta);
        if (keyW && eventAvailable.inRange) actionEvents(eventAvailable);
        p.turnSpeed *= 0.75;
        p.speed *= 0.86;
        p.direction += p.turnSpeed;
        if (p.direction > 360) p.direction = p.direction % 360;
        if (p.direction < 0) p.direction = 360 - p.direction;
        if (Math.abs(p.speed) < 0.01) p.speed = 0;
        if (Math.abs(p.turnSpeed) < 0.01) p.turnSpeed = 0;
    }
    if (!controlsEnabled && keyW) {
        controlsEnabled = true;
        uiSettings({
            title:  false,
            text: {
                newText: '',
            }
        })
    }
}

function playerActions() {
    keyPlayers(playerData);
    const {xChange, yChange} = getDirectionValues(convertToRadians(playerData.direction));
    let moveX =  xChange * playerData.speed;
    let moveY =  yChange * playerData.speed;
    let xDir = moveX > 0 ? 1 : -1;
    let yDir = moveY < 0 ? 1 : -1;
    playerData.xPos += moveX;
    setCollisionPoints(playerData);
    checkXCollision(0, 2, xDir);
    checkXCollision(1, 3, xDir);
    playerData.yPos -= moveY;
    setCollisionPoints(playerData);
    checkYCollision(0, 1, yDir);
    checkYCollision(2, 3, yDir);
}

function setCollisionPoints(object) {
    collisionPoints = [];
    collisionPoints.push({xPos: object.xPos + object.width, yPos: object.yPos - object.height})//TR
    collisionPoints.push({xPos: object.xPos + object.width, yPos: object.yPos + object.height})//BR
    collisionPoints.push({xPos: object.xPos - object.width, yPos: object.yPos - object.height})//TL
    collisionPoints.push({xPos: object.xPos - object.width, yPos: object.yPos + object.height})//BL
}

function checkXCollision(point1, point2, dirMod) {
    let checkPoint1 = collisionPoints[point1];
    let checkPoint2 = collisionPoints[point2];
    if (
        Math.floor((checkPoint1.xPos) / tileSize) * tileSize 
        !== Math.floor((checkPoint2.xPos) / tileSize) * tileSize // checks if the player xPos plus and minus width are in different columns
    ) {
        const wallX = Math.floor(checkPoint1.xPos / tileSize) * tileSize // gets the wall number from the right sided point co-ords
        let wallNumber = checkVertWalls(wallX, checkPoint1.yPos);
        if (vertWallList[wallNumber] > 0) { // checks if wall in between is solid
            playerData.xPos = wallX - ((playerData.width + 0.0001) * dirMod); // if solid moves the player a width and a small amount more away from the wall
        }
    }
}

function checkYCollision(point1, point2, dirMod) {
    let checkPoint1 = collisionPoints[point1];
    let checkPoint2 = collisionPoints[point2];
    if (
        Math.floor((checkPoint1.yPos) / tileSize) * tileSize 
        !== Math.floor((checkPoint2.yPos) / tileSize) * tileSize
    ) {
        const wallY = Math.floor(checkPoint2.yPos / tileSize) * tileSize
        let wallNumber = checkHorzWalls(checkPoint2.xPos, wallY);
        if (horzWallList[wallNumber] > 0) {
            playerData.yPos = wallY - ((playerData.height + 0.0001) * dirMod);
        }
    }
}

function getAllLines() {
    lineEndList = [];
    textureOffsetList = [];
    textureNumList = [];
    let midLine = false;
    for (let i = 0; i < scanLines; i++) {
        if (i === scanLines / 2) midLine = true;
        getSingleLineEnd(rayAngleLookup[i], midLine);
        midLine = false;
    }
}

function getSingleLineEnd(lineDir, midLine = false) {
    let xPos = playerData.xPos;
    let yPos = playerData.yPos;
    let radianDir = convertToRadians(playerData.direction) + lineDir; // Get direction of line 
    const {xChange, yChange} = getDirectionValues(radianDir); // Get x and y change value to see if direction is up/down and right/left
    let xStep = xChange < 0  ? -1 : 1; // Multipling value of tilesize based on line x axis direction
    let yStep = yChange < 0  ? -1 : 1; // Multipling value of tilesize based on line y axis direction
    let yToEdge = yChange < 0 ? tileSize - (yPos % tileSize) : yPos % tileSize; // Remainder of y distance to tile edge in relataion to line direction
    let xToEdge = xChange > 0  ? tileSize - (xPos % tileSize) : xPos % tileSize;// Remainder of x distance to tile edge in relataion to line direction
    let checkyPos = yToEdge * yStep;
    let checkxPos = xToEdge * xStep;
    let solid = 0;
    let colXpos;
    let rowXpos;
    let colYpos;
    let rowYpos;
    const stepAngle = Math.tan(radianDir);
    let rowDistance = getDistance(0, checkyPos, 0, checkyPos / stepAngle); //Line length to first row collision
    let rowStep = getDistance(0, tileSize, 0, tileSize / stepAngle); // Line length between a row
    let colDistance = getDistance(0, checkxPos, 0, checkxPos * stepAngle); //Line length to first column collision
    let colStep = getDistance(0, tileSize, 0, tileSize * stepAngle); // Line length between a column

    while (solid === 0) { //Check collisions
        if (rowDistance < colDistance) {
            rowXpos = xPos + (checkyPos / stepAngle); 
            rowYpos = yPos - (checkyPos);
            solid = horzWallList[Math.floor(checkHorzWalls(rowXpos, rowYpos))];// Checking for solid tile based to above co-ordinates}
            if (solid === 0) { // if tile is not solid then move up to next vertical line
                checkyPos += tileSize * yStep; 
                rowDistance += rowStep;
            } 
        } else {
            colXpos = xPos + (checkxPos); 
            colYpos = yPos - (checkxPos * stepAngle);
            solid = vertWallList[Math.floor(checkVertWalls(colXpos, colYpos))]// Checking for solid tile based to above co-ordinates
            if (solid === 0) {
                checkxPos += tileSize * xStep; 
                colDistance += colStep;
            }
        }
    }

    if (rowDistance < colDistance) {
        lineEndList.push(Math.round((Math.cos(lineDir) * rowDistance) * 10) / 10);
        textureOffsetList.push(Math.floor(((rowXpos /  tileSize) % 1) * textureSize));
        textureNumList.push(solid);
        if (midLine) checkEventAvailable('horz', Math.floor(checkHorzWalls(rowXpos, rowYpos)));
    } else {
        lineEndList.push(Math.round((Math.cos(lineDir) * colDistance) * 10) / 10);
        textureOffsetList.push(Math.floor(((colYpos / tileSize) % 1) * textureSize));
        textureNumList.push(solid);
        if (midLine) checkEventAvailable('vert', Math.floor(checkVertWalls(colXpos, colYpos)));
    }
}

function checkEventAvailable(direction, wallNum) {
    if (!controlsEnabled) return;
    let itemNum = lineEndList.length - 1; // The index of the wall in front in the walls list
    if (mapEventsIndex[direction].includes(wallNum) && // If wall is registered against an event
        (lineEndList[itemNum] / tileSize) < 1 ) {  // And the distance of the mid line is not within range then return
        let wallIndex =  mapEventsIndex[direction].indexOf(wallNum);
        let eventData = mapEvents[direction][wallIndex];
        if (!eventData.available) return;
        if (!eventAvailable.inRange) {
            uiSettings({text: {newText: eventData.text.cta} })
            eventAvailable.messageShowing = true;
        }
        eventAvailable.wallDir = direction;
        eventAvailable.wallIndex = wallIndex;
        eventAvailable.inRange = true;
        eventAvailable.actions = eventData.actions;
        return;
    }
    if (eventAvailable.messageShowing) {
        uiSettings({text: {newText: ''} });
        eventAvailable.messageShowing = false;
    }
    eventAvailable.inRange = false;
}

function checkVertWalls(xPos, yPos) {
    let xValue = Math.round(xPos) / tileSize;
    let yValue = Math.floor(yPos / tileSize);
    return (xValue * (mapRows)) + yValue;
}

function checkHorzWalls(xPos, yPos) {
    let xValue = Math.floor(xPos / tileSize);
    let yValue = Math.round(yPos) / tileSize;
    return (yValue * (mapColumns)) + xValue;
}

// Converts a value in degress to radians to be interpreted by javascript

function convertToRadians(direction) {
    return direction * (Math.PI / 180);
}

function getDistance(x1,x2,y1,y2) {
    let xDif = x1 - x2;
    let yDif = y1 - y2;
    return Math.sqrt((xDif *xDif) + (yDif * yDif));
}

function drawLines3d() {
    let lineXpos = resolution / 2;
    let listLength = lineEndList.length;
    for (let i = 0; i < listLength; i++) {
        draw3dLine(i, lineXpos);
        lineXpos += resolution;
    }
}

function draw3dLine(i, lineX) {
    const lineDistance = lineEndList[i];
    let textureList = allTexturesList[(textureNumList[i] - 1)]
    let textureOffset = textureOffsetList[i]; //Gets x position of line on texture
    let height = Math.floor(10 * (DV / lineDistance) * 10) / 10; // Sets vertical line drawing distance
    let brightness = Math.floor(((125 - lineDistance) / 200) * 1000) / 1000;
    if (lightingToggle) {
        if (brightness < 0.1) brightness = 0.1;
        if (brightness > 1) brightness = 1;
    }

    if (!lightingToggle) brightness = 1;
    let lineYpos = (canvasHeight / 1.8) - height; // Sets highest point on line drawing
    let drawColour; // The colour of draw section
    let newColour
    let ti = 0; // Number of repeats for texture to be drawn in a vertical line
    let scaledTextureSize = height / resolution; // Set initial value for drawing detail at a distance...
    scaledTextureSize = scaledTextureSize < 15 ? 8
                        : scaledTextureSize < 17 ? 16
                        : scaledTextureSize < 50 ? 32
                        : textureSize;  // And sets in to a half value when applicable
    let skip = Math.floor(textureSize / scaledTextureSize); // Value applied to line sections to applied scaled drawing
    let drawHeight = (((height * 2) - resolution) / textureSize) * skip; // Sets height of each section to be drawn
    let lineVMove = textureSize * skip // Value for each section of each vertical check

    while (lineYpos + drawHeight < 0) { // Moves starting draw point of line until its on screen
        lineYpos += drawHeight;
        textureOffset += textureSize;
        ti++;
    }
    ctx.moveTo(lineX, lineYpos);
    newColour = textureColours[textureList[textureOffset]]; // Set newColour to first colour to be drawn
    while (ti < scaledTextureSize) {
        drawColour = textureColours[textureList[textureOffset]];

        if( newColour != drawColour) { // if the next colour is different then draw the line up to that point
            drawLineSection(lineX,lineYpos, setRgbString(newColour, brightness))
            newColour = drawColour;
        }
        lineYpos += drawHeight; // Move another draw section down on screen
        textureOffset += lineVMove; // Move another draw section on the texture 
        if(lineYpos > canvasHeight) { // If line would be off the bottom of the screen, draw to this point and stop loop
            drawLineSection(lineX, canvasHeight, setRgbString(newColour, brightness));
            return
        }
        ti++
    }
    drawLineSection(lineX,lineYpos, setRgbString(drawColour, brightness))
}

function drawLineSection(xPos,yPos,colour) {
    const yPosMod = Math.ceil(yPos)
    ctx.strokeStyle = colour;
    ctx.lineTo(xPos, yPosMod);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(xPos, yPosMod);
}


function drawImage(image, x, y, scale = {horz: 1, vert: 1, }, render, definedCtx = ctx) {
    definedCtx.setTransform(scale.horz, 0, 0, scale.vert, x, y); 
    definedCtx.drawImage(image, Math.floor(-image.width * render.x), Math.floor(-image.height * render.y));
}

function drawBackground(scaling) {
    drawImage(images[0], 0, 0, scaling, {x: 0, y: 0}, backgroundCtx);
}

function completeUrl(urlList) {
    if (urlList === null) return;
    return urlList.map(URL => require('@/assets/images/raycasterWalls/' + URL));
}

function decodeTexture(textureData, colourMod = 0) {
    let decodedData = [];
    let dataRun = 0;
    let nextPixel = textureData[dataRun];
    while (dataRun < textureData.length) {
        nextPixel = textureData[dataRun];
        for (let i = 0; i < textureData[dataRun + 1]; i++) {
            decodedData.push(nextPixel + colourMod);
        }
    dataRun += 2;
    }
    return decodedData;
}

function decodeLevel(levelData) {
    let mapUpload = [];
    let tileRun = 0;
    let nextTile;
    let i;
    while (tileRun < levelData.length) {
        nextTile = levelData[tileRun];
        for (i = 0; i < levelData[tileRun + 1]; i++) {
            mapUpload.push(nextTile);
        }
    tileRun += 2;
    }
    return mapUpload;
}

function setRgbString(data, mod = 1) {
    const red = Math.floor(data.red * mod);
    const green = Math.floor(data.green * mod);
    const blue = Math.floor(data.blue * mod);
    return `rgb(${red},${green},${blue})`;
}

function loadImages() {
    imageURL = [...completeUrl(miscImageURL, 'backgrounds/')];
    imageURL.forEach(function(src) {
        const image = new Image();
        image.src = src;
        image.onload = function() { 
            imageCount += 1;
            if(imageCount === imageURL.length){ 
                drawBackground({horz: 1, vert: 1.1});
                draw();
            }
        }
        images.push(image); 
    });
}

function changeSetting(setting) {
    if (setting.resolution) setResolution(setting.resolution);
    if (setting.ratio) changeRatio(setting.ratio);
    if (setting.fov) {
        FOV = setting.fov;
        DV = setDV();
        setResolution(resolution);
    }
    if (setting.lighting !== undefined) {
        lightingToggle = setting.lighting;
    }
}

function changeRatio(newRatio) {
    let newHeight = Math.floor((canvasWidth / newRatio.width) * newRatio.height);
    canvasHeight = newHeight;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    backgroundCanvas.width = canvasWidth;
    backgroundCanvas.height = canvasHeight;
    let uiLayer = document.getElementById('gamescreen');
    uiLayer.width = canvasWidth;
    uiLayer.height = canvasHeight;
    setResolution(resolution);
    const vertScale = newHeight / 600;
    drawBackground({horz: 1, vert: vertScale});
}

function setResolution(newResolution) {
    resolution = newResolution;
    ctx.lineWidth = resolution;
    scanLines = Math.floor(canvasWidth / resolution);
    rayAngleLookup = createRayAngleLookup();
}

function setDV() {
    return (canvasWidth / 2) / Math.tan(convertToRadians(FOV / 2));
}

function setStartCoords(tile, mapWidth) {
    playerData.xPos = ((tile % mapWidth) * tileSize) + tileSize / 2; 
    playerData.yPos = (Math.floor(tile / mapWidth) * tileSize) + tileSize / 2;
}

function resetEventAvailable() {
    return {
        inRange: false,
        actions: [],
        wallDir: '',
        wallIndex: undefined,
        messageShowing: false,
        text: {},
    }
}

let ctx;
let canvas;
let backgroundCtx;
let backgroundCanvas;
let running = false;
const tileSize = 16;
let canvasWidth = 1074;
let canvasHeight = 608;
let vertWallList;
let horzWallList;
let mapColumns;
let mapRows;
let keyup = false;
let keydown = false;
let keyright = false;
let keyleft = false;
let keyW = false;
let lineEndList = [];
let textureOffsetList = [];
let FOV = 80;
let resolution = 3;
let DV = setDV();
let scanLines = Math.floor(canvasWidth / resolution);
const miscImageURL = [];
const images = [];
let imageURL = [];
let imageCount = 0;
let collisionPoints = [];
let textureSize = 32;
let textureColours = [];
let allTexturesList = [];
let textureNumList = [];
let lightingToggle = true;
let fps;
let fpsTick = 60;
let lastLoop = 1000;
let thisLoop = 0;
let delta = 1;
let eventAvailable = resetEventAvailable();
let mapEvents = {
    vert: [],
    horz: [],
};
let mapEventsIndex = {
    vert: [],
    horz: [],
}
let playerData = {
    xPos: 50,
    yPos: 50,
    width: 3,
    height: 3,
    direction: 290,
    turnSpeed: 0,
    strafe: 0,
    strafeSpeed: 0,
    speed: 0,
}
let rayAngleLookup = [];
let inventory = [];
let uiSettings;
let controlsEnabled;

function keyHandler(event) {
    if (["ArrowUp","ArrowDown","ArrowLeft","ArrowRight","Space"].indexOf(event.code) > -1) {
        event.preventDefault();
    }
    if (event.key === "ArrowUp") keyup = event.type === 'keydown';
    if (event.key === "ArrowDown") keydown = event.type === 'keydown';
    if (event.key === "ArrowRight") keyright = event.type === 'keydown';
    if (event.key === "ArrowLeft") keyleft = event.type === 'keydown';
    if (event.key === " ") keyW = event.type === 'keydown';
}

async function setTextures(texturesImported) {
    return texturesImported.map((textureData) => {
        let mapTextures = decodeTexture(
            textureData.encodedTexture,
            textureColours.length
        )
        textureData.colours.forEach(async (colour) =>  textureColours.push(colour));
        return mapTextures;
    })
}

function setEventData(eventsData) {
    if (!eventsData) return;
    let modedData = eventsData.map(event => {
        return {
            ...event,
            available: true,
        }
    })
    mapEvents.vert = modedData.filter(event => event.metaData.wallDirection === 'vert' );
    mapEvents.horz = modedData.filter(event => event.metaData.wallDirection === 'horz' );
    mapEventsIndex.vert = mapEvents.vert.map(event => event.metaData.wallNum);
    mapEventsIndex.horz = mapEvents.horz.map(event => event.metaData.wallNum);
}

function setItemData(itemData) {
    inventory = itemData.map(item => {
        return {
            ...item,
            value: 0,
        }
    })
}

function stopMap() {
    running = false;
    console.log('stopped')
    imageCount = 0;
    document.removeEventListener('keydown', keyHandler);
    document.removeEventListener('keyup', keyHandler);
}

async function setUpMap(levelImport, textureImport, uiChanges) {
    controlsEnabled = false
    const levelData = levelImport;
    textureSize = Number(levelImport.textureSize);
    uiSettings = uiChanges;
    allTexturesList = await setTextures(textureImport);
    vertWallList = decodeLevel(levelData.vertWallData, 'vert');
    horzWallList = decodeLevel(levelData.horzWallData, 'horz');
    miscImageURL.push(levelImport.background);
    mapColumns = levelData.verticalLines - 1;
    mapRows = levelData.horizontalLines - 1;
    setStartCoords(levelData.startTile, mapColumns);
    setItemData(JSON.parse(atob(levelData.items)));
    setEventData(JSON.parse(atob(levelData.mapEvents)));
    playerData.direction = 260;
    if (!running) startMap();
}

function createRayAngleLookup() {
    let lookupArray = [];
    let xPlace;
    let startXrayPositiion = (resolution / 2) - (canvasWidth / 2);
    for (let i = scanLines; i > 0; i--) {
        xPlace = startXrayPositiion + (i * resolution );
        lookupArray.push(Math.atan(xPlace / DV));
    }
    return lookupArray;
}

function startMap() {
    running = true;
    canvas = document.getElementById('game-layer');
    ctx = canvas.getContext('2d');
    backgroundCanvas = document.getElementById('background-layer');
    backgroundCtx = backgroundCanvas.getContext('2d');
    document.addEventListener('keydown', keyHandler, false);
    document.addEventListener('keyup', keyHandler, false);
    setResolution(resolution);
    loadImages();
}

export default setUpMap;
export {stopMap, changeSetting};